export default __webpack_public_path__ + "static/media/linkedin.dfb491d2.webp";